<template>
  
  <v-dialog v-model="show_message" persistent max-width="900" :class="{ 'detail-dialog-active': show_message }">
    
    <v-card>
      <v-card-title class="headline"><v-row>
          <v-col cols=9>Editar desglose {{get_label(vat)}}
          </v-col>    
           <v-col v-if="feature_base_retention && vat.vat && !vat.vat.includes('_re_')" cols="1" class=""></v-col>
          <v-col cols=1>
            <v-btn @click="add()" :disabled="is_einvoice"
            color="primary">
              <v-icon >mdi-plus</v-icon>
            </v-btn>
          </v-col>    
        </v-row></v-card-title>
      <v-card-text>
        <v-row no-gutters>
          <v-col cols="3" class="text-center table-head row-head primary--text">Base</v-col>
          <v-col cols="3" class="text-center table-head row-head primary--text">Cuota</v-col>
          <v-col cols="3" class="text-center table-head row-head primary--text">Cuenta</v-col>
          <v-col v-if="got_feature('feature_expense_income_type')" cols="2" class="text-center table-head row-head primary--text">Tipo Gasto/Ing.</v-col>
          <v-col v-if="feature_base_retention && vat.vat && !vat.vat.includes('_re_')" cols="1" class="text-center table-head row-head primary--text"> Apl.Ret</v-col>
          <v-col v-if="!got_feature('feature_expense_income_type')" cols="2" class=""></v-col>
        </v-row>
        <v-row no-gutters>
          
            <v-col :key="'vat_'+vat.vat" cols="3" class="table-row">
                <metadata-field 
                    kind="number" 
                    :required="Boolean(currentDocument.metadata[vat.vat])" 
                    :field-key="'base_'+vat.vat" 
                    :field-check="[vat.vat,vat.coef]" 
                    field-text="" 
                    :key="'base_'+vat.vat"/>
            </v-col>
            <v-col :key="'base_'+vat.vat" cols="3" class="table-row">
                <metadata-field 
                    kind="number" 
                    :required="Boolean(currentDocument.metadata['base_'+vat.vat])" 
                    :field-key="vat.vat" 
                    :field-check="['base_'+vat.vat,vat.coef]" 
                    field-text="" 
                    :key="vat.vat"
                /></v-col>
            <v-col :key="'account_'+vat.vat" cols="3" class="table-row">
                <metadata-field 
                    :kind="got_feature('feature_accounts_master') ? 'account_am' : 'account'"
                    :required="Boolean(currentDocument.metadata['account_'+vat.vat])" 
                    :field-key="'account_'+vat.vat" 
                    field-text="" 
                    :key="'account_'+vat.vat"
                    :num_digits="currentDocument.companydb_info.num_digits"
                    :items="got_feature('feature_accounts_master') ? accounts : []"
                    @get-values="getValues"
                    @reset-items="resetItems"
            /></v-col>
            <v-col v-if="got_feature('feature_expense_income_type')" cols="2" class="table-row">
              <v-autocomplete
                  :clearable="true"
                  :items="expens_type"
                  v-model="currentDocument.metadata[vat.vat.replace('vat','eit')]"
                  :item-text="item => item.code+' '+item.name"
                  item-value="eit_id"
                  hide-details
                  dense
              ></v-autocomplete>
            </v-col>
            <v-col v-if="feature_base_retention && vat.vat && !vat.vat.includes('_re_') " :key="'not_apl_ret_title'+vat.vat" cols="1" class="table-row">  
                <metadata-field   :field-key="'not_apl_ret_'+vat.vat" kind="boolean" field-text="" />
            </v-col>
            <v-col v-if="!got_feature('feature_expense_income_type')" :key="'label_'+vat" cols="2" class="">
            </v-col>
        </v-row>
        <v-row v-for="(linea,i) in currentDocument.metadata['detail_' + vat.vat]" :key="i" no-gutters>
            <v-col :key="'base_'+'vat_'+i+vat.vat" cols="3" class="table-row">
              <v-row no-gutters>
                  <v-col cols="3"  class="table-button" 
                          v-if="calc_error[i]">
                    <v-btn
                        color="primary"
                        :disabled="is_einvoice"
                        @click="calc_base(i)"
                        :key="'calc_base_'+i+vat.vat"
                        icon
                        >
                        <v-icon v-once>mdi-calculator-variant</v-icon>
                    </v-btn>
                  </v-col>
                  <v-col>
                    <doc-text-field 
                        kind="number" 
                        :required="Boolean(linea[vat.vat])" 
                        v-bind:value="linea['base_'+vat.vat]"
                        @input="updateField($event,i,'base_'+vat.vat)"
                        field-text="" 
                        :error="calc_error[i]"
                        :key="'base_'+i+vat.vat"
                        :disabled="is_einvoice"
                    />
                  </v-col>
              </v-row>
                
            </v-col>
            <v-col :key="'col_'+i+vat.vat" cols="3" class="table-row">
              <v-row no-gutters>
                  <v-col cols="3"  class="table-button" 
                        v-if="calc_error[i]">
                    <v-btn
                        color="primary"
                        :disabled="is_einvoice"
                        @click="calc_vat(i)"
                        icon
                        :key="'calc_'+i+vat.vat"
                        >
                        <v-icon v-once>mdi-calculator-variant</v-icon>
                    </v-btn>
                  </v-col>
                  <v-col>
                    <doc-text-field 
                        kind="number" 
                        :required="Boolean(linea[vat.vat])" 
                        v-bind:value="linea[vat.vat]"
                        @input="updateField($event,i,vat.vat)"
                        :error="calc_error[i]"
                        field-text="" 
                        :key="i+vat.vat"
                        :disabled="is_einvoice"
                    />
                  </v-col>
              </v-row>
            </v-col>
            <v-col :key="'account_col'+i+vat.vat" cols="3" class="table-row">
                <doc-text-field
                    :kind="got_feature('feature_accounts_master') ? 'account_am' : 'account'"
                    :required="true" 
                    v-bind:value="linea['account_'+vat.vat]"
                    @input="updateField($event,i,'account_'+vat.vat)"
                    :key="'account_'+i+vat.vat"
                    :num_digits="currentDocument.companydb_info.num_digits"
                    :items="got_feature('feature_accounts_master') ? accounts : []"
                    @get-values="getValues"
                    @reset-items="resetItems"
                /></v-col>
            <v-col v-if="feature_base_retention && vat.vat && !vat.vat.includes('_re_') " :key="i+vat.vat+'not_apl_ret_col'" cols="1" class="table-row">     
                <doc-text-field
                    kind="boolean" 
                    :disabled="is_einvoice"
                    v-bind:value="linea['not_apl_ret_'+vat.vat]"
                    @input="updateField($event,i,'not_apl_ret_'+vat.vat)"
                    :key="i+vat.vat+'not_apl_ret_'" />
            </v-col>
            <v-col cols="2">
              <v-btn @click="remove(i)" :disabled="is_einvoice"
              color="primary"
              icon>
                <v-icon >mdi-delete</v-icon>
              </v-btn>
            </v-col>    
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" outlined text class="primary-border" @click="closeMessage()">Cerrar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { createHelpers,mapFields } from 'vuex-map-fields';
import {mapFieldsMetadata,vuexPrefix} from "../store/vuex_utils"
import { STANDARD_LABELS_CLIENT } from "../store/constants";
import { mapActions, mapGetters } from "vuex";
import MetadataField from './MetadataField.vue'
import DocTextField from './DocTextField.vue'
import {round} from '../utils'

export default {
  name: 'DetailAccounts',
  components:{
      MetadataField,
      DocTextField,
  },
  props: {
    vat: {
      type:[Object,String],
      required:true,
      default:{}
    },
    show_message: {
      type: Boolean,
      required: true
    }
  },
  data(){
    return {
      label:''
    }
  },
  computed:{
    that(){
      return this
    },
    is_einvoice(){
      if (this.currentDocument.static_invoice){
        return true
      }
      return false
    },
    calc_error(){
      const label = 'detail_' + this.vat.vat;
      var errors = []
      if (this.currentDocument.metadata[label] && this.currentDocument.metadata[label].length){
        for(var i = 0;i<this.currentDocument.metadata[label].length;i++){
          var bas = this.currentDocument.metadata[label][i]['base_'+ this.vat.vat]? this.currentDocument.metadata[label][i]['base_'+ this.vat.vat] : 0;
          if (typeof bas == 'string'){
            bas = parseFloat(bas.replace(',','.'))
          }
          var vat = this.currentDocument.metadata[label][i][this.vat.vat]? this.currentDocument.metadata[label][i][this.vat.vat] : 0;
          if (typeof vat == 'string'){
            vat = parseFloat(vat.replace(',','.'))
          }
          errors.push(Boolean((bas*this.vat.coef<vat-this.currentDocument.companydb_info.tolerancy ||
                              bas*this.vat.coef>vat+this.currentDocument.companydb_info.tolerancy)))
          
        }
      }
      return errors
    },
    ...mapFieldsMetadata(vuexPrefix('metadata_',STANDARD_LABELS_CLIENT.map(x=>x.name),'')),
    ...mapFields('me',vuexPrefix('',['feature_base_retention'],'userData.available_features.')),
    ...mapFields('cru',['accounts']),
    ...mapFields(["expens_type"]),
    ...mapGetters({
      currentDocument: "documents/currentDocument",
      got_feature: "got_feature",
    }), 
  },
  methods:{
    ...mapActions({
      addMetadataDetailLine: "documents/addMetadataDetailLine",
      remMetadataDetailLine: "documents/remMetadataDetailLine",
      updateMetadataFieldAct:"documents/updateMetadataFieldAct",
      getMetadata: "documents/getMetadata",
      setDirty: "documents/setDirty"
    }),
    ...mapActions("cru", ['getAccounts']),
    closeMessage(){
      this.setDirty();
      this.$emit("close-message");
    },
    add(){
      const label = 'detail_' + this.vat.vat;
      let line={}
      line['base_'+this.vat.vat] = 0;
      line[this.vat.vat] = 0;
      line['account_'+this.vat.vat] = '';
      line['not_apl_ret_'+this.vat.vat] = false 
      this.addMetadataDetailLine({label, line});
    },
    remove(pos){
      const label = 'detail_' + this.vat.vat
      this.remMetadataDetailLine({pos,label})
    },
    updateField(ev,i,lab){
      const label = 'detail_' + this.vat.vat
      var value =[]
      for(var j = 0; j < this.currentDocument.metadata[label].length; j++) {
        value.push({...this.currentDocument.metadata[label][j]})
      }
      value[i][lab] = ev
      this.updateMetadataFieldAct({label,value})
    },
    calc_vat(i){
      const label = 'detail_' + this.vat.vat  
      var bas = this.currentDocument.metadata[label][i]['base_'+ this.vat.vat]? this.currentDocument.metadata[label][i]['base_'+ this.vat.vat] : 0;
      if (typeof bas == 'string'){
        bas = parseFloat(bas.replace(',','.'))
      }
      var new_vat = round(bas*this.vat.coef,2)
      this.updateField(new_vat,i,this.vat.vat)
    },
    calc_base(i){
      const label = 'detail_' + this.vat.vat
      var vat = this.currentDocument.metadata[label][i][this.vat.vat]? this.currentDocument.metadata[label][i][this.vat.vat] : 0;
      if (typeof vat == 'string'){
        vat = parseFloat(vat.replace(',','.'))
      }
      var new_bas = round(vat/this.vat.coef,2)
      this.updateField(new_bas,i,'base_'+this.vat.vat)
    },
    getValues(params) {
        this.getAccounts(params).then(() => {});
    },
    resetItems(params) {
      this.accounts = params;
    },
    get_label(vat){
      if(vat.vat == 'vat_0' && !this.got_feature('feature_exenta_no_sujeta')){
          return '0%'
      }
      return vat.label
    },
  },
  watch: {
    show_message(activate) {
      const element = document.body.classList;
      activate 
        ? element.add('detail-dialog-active') 
        : element.remove('detail-dialog-active');
    }
  },
  beforeDestroy() {
    document.body.classList.remove('detail-dialog-active');
  }

}
</script>

<style scoped>
    .table-head{
      border-left-style:solid;
      border-right-style:solid;
      border-bottom-style:solid;
      border-color:var(--v-primary-base);
      border-width: thin;
    }
    .row-head {
      border-top-style:solid;
      border-color:var(--v-primary-base);
      border-width: thin;
    }
    .table-row{
      border-left-style:solid;
      border-right-style:solid;
      border-bottom-style:solid;
      border-color:var(--v-primary-base);
      border-width: thin;
    }
    .table-row >>> div > .row > .col > div > .v-text-field {
      margin-top: 0px;
    }
    .table-row >>> div > .v-text-field {
      margin-top: 0px;
    }
    .table-row >>> div > .row > .col > div > .v-text-field > .v-input__control > .v-input__slot {
      height: 36px;
    }
    .table-row >>> div > .v-text-field > .v-input__control > .v-input__slot {
      height: 36px;
    }

</style>
<style lang="scss" scoped>
  .primary-bckground {
    background-color: var(--v-primary-base);
  }
  .primary-border {
    border-color: var(--v-primary-base) !important;
  }
  
</style>
<style scoped>

    .table-button {
        border-bottom-style:solid;
        border-width: thin;
        border-bottom-color: rgba(0,0,0,.42);
        margin-bottom: -1px;
    }

</style>

<style>
.detail-dialog-active {
  .v-overlay.v-overlay--active {
    z-index: 201 !important;
  }
  .v-main__wrap {
    z-index: 202 !important;
  }
  .v-dialog {
    margin: auto !important;
    border: 2px solid gray;
  }
  .v-dialog__content {
    flex-direction: row !important;
    justify-content: right !important;
  }
  .v-card {
    width: 100% !important;
  }
  .v-card__actions {
    flex-direction: column !important;
    align-items: center !important;
  }

  @media (max-width: 1440px) {
    .v-dialog {
      width: 51.8% !important;
    }
  }

} 
</style>
